import { SessionAccountTypeEnum } from '../../generated/graphql'

const { VITE_ENV_NAME } = import.meta.env

export const resolveEnvironment = (
  accountType: SessionAccountTypeEnum | null | undefined,
): string | undefined => {
  if (VITE_ENV_NAME === 'local') {
    return 'development'
  }
  switch (accountType) {
    case SessionAccountTypeEnum.Production:
      return 'production'
    case SessionAccountTypeEnum.Sandbox:
      return 'production-sandbox'
    case SessionAccountTypeEnum.Test:
      return 'test'
    default: {
      return undefined
    }
  }
}
